export var reduxKey = '@@ArtBrandedPopup';
//# sourceMappingURL=constants.js.map